<template>
  <template-item
    :model="$productGroup"
    :show-delete="false"
    v-slot="{ object, rules }"
    title-prepend="Группы блюд / "
    object-key-for-title="name"
    :before-save="beforeItemSave"
    :after-save="afterSave"
  >
    <div>
      Наименование из учетной системы:
      <span class="font-weight-bold">{{ object.vendor_name || 'Отсутствует' }}</span>
    </div>
    <ImageUploader
      :image="object.image"
      class="mt-4"
      height="140"
      width="140"
      @input="uploadImage($event, 'image')"
    ></ImageUploader>
    <v-text-field
      v-model="object.name"
      outlined
      hide-details
      dense
      label="Клиентское наименование"
      class="mt-4"
    />
    <v-text-field
      v-model="object.sorting"
      type="number"
      outlined
      hide-details
      dense
      label="Сортировка"
      class="mt-4"
    />
    <v-checkbox
      class="pa-0 ma-0 py-4"
      hide-details
      label="Отображать в приложении"
      v-model="object.show_in_app"
    ></v-checkbox>
    <v-row
      align="center"
      class="my-3"
      no-gutters
    >
      <div class="text-h6 mr-3">Кросс-сейл</div>
      <v-divider />
    </v-row>
    <ProductGroupCrossSellItem />
  </template-item>
</template>

<script>
  import imageUpload from '../../../vendor/imageUpload'
  import ImageUploader from '@/admin/components/ImageUploader'
  import ProductGroupCrossSellItem from './components/ProductGroupCrossSellItem.vue'

  export default {
    name: 'ProductGroupItem',

    mixins: [imageUpload],
    components: {
      ImageUploader,
      ProductGroupCrossSellItem
    },

    data: () => ({
      imagesToSetAfterCreateByField: {}
    }),

    methods: {
      async uploadImage(file, field) {
        if (!this.$productGroup.item.id) {
          const reader = new FileReader()
          reader.readAsDataURL(file)
          this.imagesToSetAfterCreateByField[field] = file
          reader.onload = () => {
            Object.assign(this.$productGroup.item, { [field]: reader.result })
          }
        } else {
          const formData = new FormData()
          formData.append('image', file)
          formData.append('type', field)
          const res = await this.$productGroup.sendPutSingle(
            'upload_image',
            this.$productGroup.item.id,
            formData
          )
          this.$productGroup.item[field] = res.url
          this.$store.commit('setSnackbar', {
            color: 'success',
            text: 'Изображение сохранено'
          })
        }
      },

      beforeItemSave(item) {
        const isBase64 = v => typeof v === 'string' && v.startsWith('data:') && v.includes('base64')
        if (isBase64(item.image)) item.image = null
      },

      afterSave(_) {
        for (const field of Object.keys(this.imagesToSetAfterCreateByField)) {
          void this.uploadImage(this.imagesToSetAfterCreateByField[field], field)
        }
      }
    }
  }
</script>
